import { restClient } from '@/Core'
import type { ChatNotificationLevel } from '../Contracts'
import { toNotificationLevel } from '../Helpers/apiMappers'

interface SetNotificationsResponse {
    level?: string
}

/** Sets the personal notification level of the chat (participant-only, 404 otherwise) */
export const SetChatNotificationsTask = async (
    chatId: string,
    level: ChatNotificationLevel
): Promise<ChatNotificationLevel> => {
    const response = (await restClient.patch(`/services/chat/chats/${chatId}/notifications`, {
        json: { level },
    })) as SetNotificationsResponse | null

    return toNotificationLevel(response?.level)
}
